/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Providers.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  GetPatientsParams,
  PatientAccountInformationDoctorApiInContract,
  PatientDoctorCohortsApiOutContract,
  PatientGeneralInformationStaffApiInContract,
  PatientIdentityVerificationDetailsStaffApiOutContract,
  PatientListItemStaffApiOutContract,
  PatientStaffApiOutContract,
  PrescriptionMonitoringProgramOutContract
} from '../pwrdbyQuickMDProvidersApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | OffsetNotValid | Offset is negative |
| 400 | CountNotValid | Count is zero or negative |
| 400 | BirthDateNotValid | BirthDate is not a valid date string |
| 400 | SearchValueNotValid | SearchValue is required when BirthDate is absent, and must be at least 3 characters |
 * @summary Get a filtered collection of patients
 */
export const getPatients = (
    params?: GetPatientsParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PatientListItemStaffApiOutContract[]>(
      {url: `https://providers-api.api.quick.md/api/v1/patients`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPatientsInfiniteQueryKey = (params?: GetPatientsParams,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/patients`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetPatientsQueryKey = (params?: GetPatientsParams,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/patients`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPatientsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(params?: GetPatientsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatients>>> = ({ signal }) => getPatients(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatients>>>
export type GetPatientsInfiniteQueryError = ErrorApiOutContract | void


export function useGetPatientsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(
 params: undefined |  GetPatientsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatients>>,
          TError,
          Awaited<ReturnType<typeof getPatients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatients>>,
          TError,
          Awaited<ReturnType<typeof getPatients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a filtered collection of patients
 */

export function useGetPatientsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get a filtered collection of patients
 */
export const prefetchGetPatientsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 queryClient: QueryClient, params?: GetPatientsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsInfiniteQueryOptions(params,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsQueryOptions = <TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(params?: GetPatientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatients>>> = ({ signal }) => getPatients(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsQueryResult = NonNullable<Awaited<ReturnType<typeof getPatients>>>
export type GetPatientsQueryError = ErrorApiOutContract | void


export function useGetPatients<TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 params: undefined |  GetPatientsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatients>>,
          TError,
          Awaited<ReturnType<typeof getPatients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatients<TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatients>>,
          TError,
          Awaited<ReturnType<typeof getPatients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatients<TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a filtered collection of patients
 */

export function useGetPatients<TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get a filtered collection of patients
 */
export const prefetchGetPatientsQuery = async <TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 queryClient: QueryClient, params?: GetPatientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(params?: GetPatientsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatients>>> = ({ signal }) => getPatients(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatients>>>
export type GetPatientsSuspenseQueryError = ErrorApiOutContract | void


export function useGetPatientsSuspense<TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 params: undefined |  GetPatientsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsSuspense<TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsSuspense<TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a filtered collection of patients
 */

export function useGetPatientsSuspense<TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(params?: GetPatientsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatients>>> = ({ signal }) => getPatients(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatients>>>
export type GetPatientsSuspenseInfiniteQueryError = ErrorApiOutContract | void


export function useGetPatientsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(
 params: undefined |  GetPatientsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a filtered collection of patients
 */

export function useGetPatientsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 404 | PatientNotFound | Patient with sent identifier is not found |
 * @summary Get a patient profile by their Id
 */
export const getPatientsPatientId = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PatientStaffApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdInfiniteQueryKey = (patientId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/patients/${patientId}`
    ] as const;
    }

export const getGetPatientsPatientIdQueryKey = (patientId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/patients/${patientId}`
    ] as const;
    }

    
export const getGetPatientsPatientIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientId>>> = ({ signal }) => getPatientsPatientId(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientId>>>
export type GetPatientsPatientIdInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a patient profile by their Id
 */

export function useGetPatientsPatientIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdInfiniteQueryOptions(patientId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get a patient profile by their Id
 */
export const prefetchGetPatientsPatientIdInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdInfiniteQueryOptions(patientId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientId>>> = ({ signal }) => getPatientsPatientId(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientId>>>
export type GetPatientsPatientIdQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientId<TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientId<TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientId<TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a patient profile by their Id
 */

export function useGetPatientsPatientId<TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get a patient profile by their Id
 */
export const prefetchGetPatientsPatientIdQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdQueryOptions(patientId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientId>>> = ({ signal }) => getPatientsPatientId(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientId>>>
export type GetPatientsPatientIdSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a patient profile by their Id
 */

export function useGetPatientsPatientIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdSuspenseQueryOptions(patientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientId>>> = ({ signal }) => getPatientsPatientId(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientId>>>
export type GetPatientsPatientIdSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a patient profile by their Id
 */

export function useGetPatientsPatientIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdSuspenseInfiniteQueryOptions(patientId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putPatientsPatientIdAccountinfo = (
    patientId: string,
    patientAccountInformationDoctorApiInContract: PatientAccountInformationDoctorApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/accountinfo`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: patientAccountInformationDoctorApiInContract
    },
      options);
    }
  


export const getPutPatientsPatientIdAccountinfoMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdAccountinfo>>, TError,{patientId: string;data: PatientAccountInformationDoctorApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdAccountinfo>>, TError,{patientId: string;data: PatientAccountInformationDoctorApiInContract}, TContext> => {

const mutationKey = ['putPatientsPatientIdAccountinfo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPatientsPatientIdAccountinfo>>, {patientId: string;data: PatientAccountInformationDoctorApiInContract}> = (props) => {
          const {patientId,data} = props ?? {};

          return  putPatientsPatientIdAccountinfo(patientId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPatientsPatientIdAccountinfoMutationResult = NonNullable<Awaited<ReturnType<typeof putPatientsPatientIdAccountinfo>>>
    export type PutPatientsPatientIdAccountinfoMutationBody = PatientAccountInformationDoctorApiInContract
    export type PutPatientsPatientIdAccountinfoMutationError = void | ErrorApiOutContract

    export const usePutPatientsPatientIdAccountinfo = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdAccountinfo>>, TError,{patientId: string;data: PatientAccountInformationDoctorApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPatientsPatientIdAccountinfo>>,
        TError,
        {patientId: string;data: PatientAccountInformationDoctorApiInContract},
        TContext
      > => {

      const mutationOptions = getPutPatientsPatientIdAccountinfoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putPatientsPatientIdGeneralinfo = (
    patientId: string,
    patientGeneralInformationStaffApiInContract: PatientGeneralInformationStaffApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/generalinfo`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: patientGeneralInformationStaffApiInContract
    },
      options);
    }
  


export const getPutPatientsPatientIdGeneralinfoMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdGeneralinfo>>, TError,{patientId: string;data: PatientGeneralInformationStaffApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdGeneralinfo>>, TError,{patientId: string;data: PatientGeneralInformationStaffApiInContract}, TContext> => {

const mutationKey = ['putPatientsPatientIdGeneralinfo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPatientsPatientIdGeneralinfo>>, {patientId: string;data: PatientGeneralInformationStaffApiInContract}> = (props) => {
          const {patientId,data} = props ?? {};

          return  putPatientsPatientIdGeneralinfo(patientId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPatientsPatientIdGeneralinfoMutationResult = NonNullable<Awaited<ReturnType<typeof putPatientsPatientIdGeneralinfo>>>
    export type PutPatientsPatientIdGeneralinfoMutationBody = PatientGeneralInformationStaffApiInContract
    export type PutPatientsPatientIdGeneralinfoMutationError = void | ErrorApiOutContract

    export const usePutPatientsPatientIdGeneralinfo = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdGeneralinfo>>, TError,{patientId: string;data: PatientGeneralInformationStaffApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPatientsPatientIdGeneralinfo>>,
        TError,
        {patientId: string;data: PatientGeneralInformationStaffApiInContract},
        TContext
      > => {

      const mutationOptions = getPutPatientsPatientIdGeneralinfoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Returns the intersection of the active cohorts that both the patient and provider are enrolled in
 */
export const getPatientsPatientIdCohorts = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PatientDoctorCohortsApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/cohorts`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdCohortsInfiniteQueryKey = (patientId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/patients/${patientId}/cohorts`
    ] as const;
    }

export const getGetPatientsPatientIdCohortsQueryKey = (patientId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/patients/${patientId}/cohorts`
    ] as const;
    }

    
export const getGetPatientsPatientIdCohortsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdCohortsInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>> = ({ signal }) => getPatientsPatientIdCohorts(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdCohortsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>>
export type GetPatientsPatientIdCohortsInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdCohortsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdCohortsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdCohortsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the intersection of the active cohorts that both the patient and provider are enrolled in
 */

export function useGetPatientsPatientIdCohortsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdCohortsInfiniteQueryOptions(patientId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Returns the intersection of the active cohorts that both the patient and provider are enrolled in
 */
export const prefetchGetPatientsPatientIdCohortsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdCohortsInfiniteQueryOptions(patientId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdCohortsQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdCohortsQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>> = ({ signal }) => getPatientsPatientIdCohorts(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdCohortsQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>>
export type GetPatientsPatientIdCohortsQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdCohorts<TData = Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdCohorts<TData = Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdCohorts<TData = Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the intersection of the active cohorts that both the patient and provider are enrolled in
 */

export function useGetPatientsPatientIdCohorts<TData = Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdCohortsQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Returns the intersection of the active cohorts that both the patient and provider are enrolled in
 */
export const prefetchGetPatientsPatientIdCohortsQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdCohortsQueryOptions(patientId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdCohortsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdCohortsQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>> = ({ signal }) => getPatientsPatientIdCohorts(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdCohortsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>>
export type GetPatientsPatientIdCohortsSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdCohortsSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdCohortsSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdCohortsSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the intersection of the active cohorts that both the patient and provider are enrolled in
 */

export function useGetPatientsPatientIdCohortsSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdCohortsSuspenseQueryOptions(patientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdCohortsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdCohortsInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>> = ({ signal }) => getPatientsPatientIdCohorts(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdCohortsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>>
export type GetPatientsPatientIdCohortsSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdCohortsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdCohortsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdCohortsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the intersection of the active cohorts that both the patient and provider are enrolled in
 */

export function useGetPatientsPatientIdCohortsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdCohorts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdCohortsSuspenseInfiniteQueryOptions(patientId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPatientsPatientIdIdentityverification = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PatientIdentityVerificationDetailsStaffApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/identityverification`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdIdentityverificationInfiniteQueryKey = (patientId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/patients/${patientId}/identityverification`
    ] as const;
    }

export const getGetPatientsPatientIdIdentityverificationQueryKey = (patientId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/patients/${patientId}/identityverification`
    ] as const;
    }

    
export const getGetPatientsPatientIdIdentityverificationInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdIdentityverificationInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>> = ({ signal }) => getPatientsPatientIdIdentityverification(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdIdentityverificationInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>
export type GetPatientsPatientIdIdentityverificationInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdIdentityverificationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdIdentityverificationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdIdentityverificationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdIdentityverificationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdIdentityverificationInfiniteQueryOptions(patientId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdIdentityverificationInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdIdentityverificationInfiniteQueryOptions(patientId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdIdentityverificationQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdIdentityverificationQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>> = ({ signal }) => getPatientsPatientIdIdentityverification(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdIdentityverificationQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>
export type GetPatientsPatientIdIdentityverificationQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdIdentityverification<TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdIdentityverification<TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdIdentityverification<TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdIdentityverification<TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdIdentityverificationQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdIdentityverificationQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdIdentityverificationQueryOptions(patientId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdIdentityverificationSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdIdentityverificationQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>> = ({ signal }) => getPatientsPatientIdIdentityverification(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdIdentityverificationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>
export type GetPatientsPatientIdIdentityverificationSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdIdentityverificationSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdIdentityverificationSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdIdentityverificationSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdIdentityverificationSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdIdentityverificationSuspenseQueryOptions(patientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdIdentityverificationSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdIdentityverificationInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>> = ({ signal }) => getPatientsPatientIdIdentityverification(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdIdentityverificationSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>
export type GetPatientsPatientIdIdentityverificationSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdIdentityverificationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdIdentityverificationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdIdentityverificationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdIdentityverificationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdIdentityverificationSuspenseInfiniteQueryOptions(patientId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPatientsPatientIdPrescriptionMonitoringProgram = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PrescriptionMonitoringProgramOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/prescription-monitoring-program`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdPrescriptionMonitoringProgramInfiniteQueryKey = (patientId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/patients/${patientId}/prescription-monitoring-program`
    ] as const;
    }

export const getGetPatientsPatientIdPrescriptionMonitoringProgramQueryKey = (patientId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/patients/${patientId}/prescription-monitoring-program`
    ] as const;
    }

    
export const getGetPatientsPatientIdPrescriptionMonitoringProgramInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPrescriptionMonitoringProgramInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>> = ({ signal }) => getPatientsPatientIdPrescriptionMonitoringProgram(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPrescriptionMonitoringProgramInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>>
export type GetPatientsPatientIdPrescriptionMonitoringProgramInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPrescriptionMonitoringProgramInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionMonitoringProgramInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionMonitoringProgramInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdPrescriptionMonitoringProgramInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPrescriptionMonitoringProgramInfiniteQueryOptions(patientId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdPrescriptionMonitoringProgramInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdPrescriptionMonitoringProgramInfiniteQueryOptions(patientId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdPrescriptionMonitoringProgramQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPrescriptionMonitoringProgramQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>> = ({ signal }) => getPatientsPatientIdPrescriptionMonitoringProgram(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPrescriptionMonitoringProgramQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>>
export type GetPatientsPatientIdPrescriptionMonitoringProgramQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPrescriptionMonitoringProgram<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionMonitoringProgram<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionMonitoringProgram<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdPrescriptionMonitoringProgram<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPrescriptionMonitoringProgramQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdPrescriptionMonitoringProgramQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdPrescriptionMonitoringProgramQueryOptions(patientId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdPrescriptionMonitoringProgramSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPrescriptionMonitoringProgramQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>> = ({ signal }) => getPatientsPatientIdPrescriptionMonitoringProgram(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPrescriptionMonitoringProgramSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>>
export type GetPatientsPatientIdPrescriptionMonitoringProgramSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPrescriptionMonitoringProgramSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionMonitoringProgramSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionMonitoringProgramSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdPrescriptionMonitoringProgramSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPrescriptionMonitoringProgramSuspenseQueryOptions(patientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdPrescriptionMonitoringProgramSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPrescriptionMonitoringProgramInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>> = ({ signal }) => getPatientsPatientIdPrescriptionMonitoringProgram(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPrescriptionMonitoringProgramSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>>
export type GetPatientsPatientIdPrescriptionMonitoringProgramSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPrescriptionMonitoringProgramSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionMonitoringProgramSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionMonitoringProgramSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdPrescriptionMonitoringProgramSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptionMonitoringProgram>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPrescriptionMonitoringProgramSuspenseInfiniteQueryOptions(patientId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




